// Marketing popup — a fully independent, self-contained campaign popup. Not built on top of
// parts/dialog.twig / lib/dialog.js (decoupled so this feature has zero dependency on the
// shared dialog component) — implements its own show/hide, focus trap, Escape-to-close, and
// body scroll lock, scoped to this popup only. See parts/marketing-popup.twig for the markup.
const FOCUSABLE_SELECTOR =
    'a[href], button:not([disabled]), textarea:not([disabled]), input:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])';

var DISMISSED_UNTIL_KEY = 'twifi_popup_dismissed_until';
var DISMISS_DAYS = 7;

document.addEventListener('DOMContentLoaded', () => {
    var modal = document.getElementById('marketingPopupModal');

    // Guard: the popup markup only exists when side_wide_active is true.
    if (!modal) return;

    var dismissedUntil = parseInt(localStorage.getItem(DISMISSED_UNTIL_KEY), 10);
    if (dismissedUntil && Date.now() < dismissedUntil) return;

    var lastFocused = null;

    function getFocusableElements() {
        return Array.from(modal.querySelectorAll(FOCUSABLE_SELECTOR));
    }

    function openPopup() {
        lastFocused = document.activeElement;
        modal.hidden = false;
        document.body.classList.add('has-open-marketing-popup');

        var closeButton = modal.querySelector('.marketing-popup__close');
        if (closeButton) closeButton.focus();

        modal.dispatchEvent(new CustomEvent('marketing-popup:open'));
    }

    function closePopup() {
        modal.hidden = true;
        document.body.classList.remove('has-open-marketing-popup');

        if (lastFocused) lastFocused.focus();

        var expiry = Date.now() + DISMISS_DAYS * 24 * 60 * 60 * 1000;
        localStorage.setItem(DISMISSED_UNTIL_KEY, String(expiry));

        modal.dispatchEvent(new CustomEvent('marketing-popup:close'));
    }

    modal.querySelectorAll('[data-popup-dismiss]').forEach(function (dismiss) {
        dismiss.addEventListener('click', closePopup);
    });

    modal.addEventListener('keydown', function (event) {
        if (modal.hidden) return;

        if (event.key === 'Escape') {
            closePopup();
            return;
        }

        if (event.key !== 'Tab') return;

        var focusable = getFocusableElements();
        if (!focusable.length) return;

        var first = focusable[0];
        var last = focusable[focusable.length - 1];

        if (event.shiftKey && document.activeElement === first) {
            event.preventDefault();
            last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
            event.preventDefault();
            first.focus();
        }
    });

    window.addEventListener('load', function () {
        setTimeout(openPopup, 3000);
    });

    var copyButton = modal.querySelector('.marketing-popup__code-copy');
    if (copyButton) {
        copyButton.addEventListener('click', function () {
            var value = copyButton.dataset.copyValue;
            var copiedLabel = copyButton.dataset.copiedLabel;
            var copyLabel = copyButton.dataset.copyLabel;

            navigator.clipboard
                .writeText(value)
                .then(function () {
                    copyButton.textContent = copiedLabel;
                    copyButton.setAttribute('data-copied', '');

                    setTimeout(function () {
                        copyButton.textContent = copyLabel;
                        copyButton.removeAttribute('data-copied');
                    }, 2000);
                })
                .catch(function (err) {
                    console.error('Failed to copy discount code:', err);
                });
        });
    }
});
